import { styled } from "@mui/material";

export const Styled = {
    ListItem: styled("li", { shouldForwardProp: prop => prop !== "isSelected" })<{
        isSelected?: boolean;
    }>`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        cursor: pointer;
        border: 1px solid
            ${props => (props.isSelected ? "transparent" : props.theme.palette.primary.main)};
        border-radius: 4px;
        padding: 0px 15px;
        background-color: ${props =>
            props.isSelected ? props.theme.palette.primary.main : "transparent"};
        width: 350px;
        height: 100px;
        transition: 0.15s linear;
        &:hover {
            background-color: ${props => props.theme.palette.primary.main};
            border-color: "transparent";
            & svg,
            h4,
            h6 {
                color: white;
            }
        }
    `,
};
